const editDriverOptions = [
    "Select from the following...",
    "No longer drives policy vehicles and still resides in household.",
    "No longer has valid driver’s license.",
    "No longer resides in household."
];

export default editDriverOptions